import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import VueMeta from "vue-meta";
import "./assets/styles/global.less";

import AOS from "aos";
import "aos/dist/aos.css";

// import Observe from "@/directives/observe";

// Vue.directive("observe", Observe);

// 使用Vue Meta插件
Vue.use(VueMeta, {
  refreshOnceOnNavigation: true
});

AOS.init();

// 默认的SEO配置
const defaultMeta = {
  title: "YOLEE - Industrial Machinery Manufacturing",
  meta: [
    { charset: 'utf-8' },
    { name: 'viewport', content: 'width=device-width,initial-scale=1.0' },
    { name: 'description', content: 'YOLEE provides high-quality industrial machinery for abrasive belt and flap disc manufacturing. Professional equipment solutions since 2005.' },
    { name: 'keywords', content: 'industrial machinery, abrasive belt, flap disc, manufacturing equipment, YOLEE, ABR, machinery solutions' }
  ]
};

router.beforeEach((to, from, next) => {
  let pageMeta = { ...defaultMeta };

  if (to.name === "Home") {
    pageMeta.title = "YOLEE - Industrial Machinery Manufacturing Solutions";
    pageMeta.meta = [
      ...defaultMeta.meta,
      { name: 'description', content: 'YOLEE provides complete industrial machinery solutions for abrasive belt and flap disc manufacturing. High-quality equipment with global standards.' }
    ];
  } else if (to.name === "MainCategory") {
    const categoryName = to.params.mainCategoryId === 'Abrasive-Belt' ? 'Abrasive Belt Machinery' : 'Flap Disc Machinery';
    pageMeta.title = `YOLEE - ${categoryName} | Industrial Equipment`;
    pageMeta.meta = [
      ...defaultMeta.meta,
      { name: 'description', content: `Professional ${categoryName.toLowerCase()} solutions from YOLEE. High-precision equipment for industrial manufacturing needs.` }
    ];
  } else if (to.name === "SubCategory") {
    const subCategory = to.params.subCategoryId.replace(/-/g, ' ');
    pageMeta.title = `YOLEE - ${subCategory} Equipment | Machinery Solutions`;
    pageMeta.meta = [
      ...defaultMeta.meta,
      { name: 'description', content: `Specialized ${subCategory} equipment from YOLEE. High-performance industrial machinery for manufacturing applications.` }
    ];
  } else if (to.name === "ProductDetail") {
    const productId = to.params.id;
    pageMeta.title = `YOLEE - ${productId.replace(/-/g, ' ')} | Industrial Machine`;
    pageMeta.meta = [
      ...defaultMeta.meta,
      { name: 'description', content: `Professional ${productId.replace(/-/g, ' ')} machine from YOLEE. High-quality industrial equipment with advanced features.` }
    ];
  } else if (to.name === "Contact") {
    pageMeta.title = "YOLEE - Contact Us | Industrial Machinery Support";
    pageMeta.meta = [
      ...defaultMeta.meta,
      { name: 'description', content: 'Contact YOLEE for industrial machinery inquiries, technical support, and equipment solutions. Global manufacturing equipment provider.' }
    ];
  } else if (to.name === "About") {
    pageMeta.title = "YOLEE - About Us | Industrial Machinery Manufacturer";
    pageMeta.meta = [
      ...defaultMeta.meta,
      { name: 'description', content: 'Learn about YOLEE, a professional industrial machinery manufacturer specializing in abrasive belt and flap disc equipment since 2005.' }
    ];
  } else if (to.name === "Policy") {
    pageMeta.title = "YOLEE - Privacy Policy";
    pageMeta.meta = [
      ...defaultMeta.meta,
      { name: 'robots', content: 'noindex, nofollow' }
    ];
  } else if (to.name === "TermsOfService") {
    pageMeta.title = "YOLEE - Terms of Service";
    pageMeta.meta = [
      ...defaultMeta.meta,
      { name: 'robots', content: 'noindex, nofollow' }
    ];
  } else {
    pageMeta.title = "YOLEE";
  }

  // 设置文档标题（向后兼容）
  document.title = pageMeta.title;
  
  // 使用Vue Meta的API来设置元数据，而不是直接修改to.meta
  to.matched.forEach(record => {
    record.meta = pageMeta;
  });
  
  next();
});

new Vue({
  router,
  ...defaultMeta,
  render: (h) => h(App),
}).$mount("#app");